/* global axios */
import ApiClient from './ApiClient';

class AttributeAPI extends ApiClient {
  constructor() {
    super('custom_attribute_definitions', { accountScoped: true });
  }

  getAttributesByModel() {
    return axios.get(this.url);
  }

  reorder({ attributeModel, orderedIds }) {
    return axios.patch(`${this.url}/reorder`, {
      attribute_model: attributeModel,
      ordered_ids: orderedIds,
    });
  }
}

export default new AttributeAPI();
